import React from "react";
import { useAuth } from "@/providers/AuthProvider";
import { LogIn } from "@/components/LogIn";
import { Loader } from "@/components/ui/loader";
import { Button } from "@/components/ui/button";
import { Teams } from "@/components/Teams";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading, teams, error, refetchGeneralData } = useAuth();

  if (isLoading || (!teams && user && !error)) {
    return (
      <div className="flex mt-8 justify-center">
        <Loader />
      </div>
    );
  }

  if (user && (!teams || teams.length === 0)) {
    return <Teams />;
  }

  if (error && user) {
    // Show error state with retry button
    return (
      <div className="flex flex-col items-center justify-center mt-8 p-4">
        <div className="text-red-500 mb-4">{error}</div>
        <Button onClick={() => refetchGeneralData?.()} variant="outline">
          Retry
        </Button>
      </div>
    );
  }

  if (!user) {
    return <LogIn />;
  }

  return <>{children}</>;
}
